import { Subject } from 'rxjs'
import { Injectable } from '@tanbo/vue-di-plugin'

@Injectable()
export class UserInfoService {
  onRenew = new Subject()
}
